    import React, { useState } from "react";
    import { motion, AnimatePresence } from "framer-motion";
    import "../styles/JobCard.css";
    import { FiBriefcase, FiMapPin, FiClock, FiSend, FiExternalLink, FiX } from "react-icons/fi";
    import { FiCheckCircle, FiArrowLeft } from "react-icons/fi";
    import { useEffect } from "react";
import { useLocation } from "react-router-dom";
    const jobs = [
    // {
    //     title: "Business Development Officer",
    //     department: "Business",
    //     location: "Accra, Ghana",
    //     posted: "27th July, 2025",
    //     description:
    //     "Responsible for identifying growth opportunities, building strategic partnerships, and driving sales to expand the company's market presence.",
    //     tags: ["Sales", "Partnerships", "Market Expansion", "Client Relations", "Strategy"],
    // },
    // {
    //     title: "Program & Training Coordinator",
    //     department: "Programs",
    //     location: "Accra, Ghana",
    //     posted: "27th July, 2025",
    //     description:
    //     "Plans, organizes, and oversees training programs and organizational projects, ensuring they run efficiently and meet set goals.",
    //     tags: ["Training", "Program Management", "Coordination", "Capacity Building", "Project Planning"],
    // },
    // {
    //     title: "Account Officer",
    //     department: "Finance",
    //     location: "Accra, Ghana",
    //     posted: "27th July, 2025",
    //     description:
    //     "Manages client financial records, processes transactions, and ensures accuracy in billing, reporting, and account reconciliation.",
    //     tags: ["Finance", "Accounting", "Bookkeeping", "Reconciliation", "Reporting"],
    // },
    ];

    const JobCard = () => {
    const [selectedJob, setSelectedJob] = useState(null);
    const [showThankYou, setShowThankYou] = useState(false);
    const [formSubmitting, setFormSubmitting] = useState(false);

    const closeModal = () => setSelectedJob(null);

    const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitting(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
    const response = await fetch("https://getform.io/f/bolovmea", {
        method: "POST",
        body: formData,
    });

    if (response.ok) {
        form.reset();
        setShowThankYou(true);
        setSelectedJob(null);
    } else {
        alert("Something went wrong. Please try again.");
    }
    } catch (err) {
    alert("Submission failed.");
    } finally {
    setFormSubmitting(false);
    }
};

const location = useLocation();

useEffect(() => {
    if (location.hash) {
    const target = document.getElementById(location.hash.replace("#", ""));
    if (target) {
        target.scrollIntoView({ behavior: "smooth" });
    }
    }
}, [location]);


    return (
        <>
<div className="job-cards-section">
  {jobs.length === 0 ? (
    <motion.p
      className="no-jobs-message"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      There are no career roles available at the moment, check back later.
    </motion.p>
  ) : (
    jobs.map((job, index) => (
      <motion.div
        className="job-card"
        key={index}
        whileHover={{ scale: 1.02 }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: index * 0.1 }}
      >
        <h3 className="job-title" id="jobs">{job.title}</h3>
        <div className="job-meta">
          <span><FiBriefcase size={16} /> {job.department}</span>
          <span><FiMapPin size={16} /> {job.location}</span>
          <span><FiClock size={16} /> {job.posted}</span>
        </div>
        <p className="job-description">{job.description}</p>
        <div className="job-tags">
          {job.tags.map((tag, i) => (
            <span className="tag" key={i}>{tag}</span>
          ))}
        </div>
        <div className="job-actions">
          <a href="mailto:info@nexagrowthafrica.org" className="link-text">
            <button className="view-details">
              <FiExternalLink size={16} /> Contact Us
            </button>
          </a>
          <button className="apply-now" onClick={() => setSelectedJob(job)}>
            <FiSend size={16} /> Apply Now
          </button>
        </div>
      </motion.div>
    ))
  )}
</div>
        <AnimatePresence>
            {selectedJob && (
            <motion.div
                className="job-modal-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                className="job-modal-content"
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
                transition={{ duration: 0.3 }}
                >
                <div className="job-modal-header">
                    <h2>Apply for {selectedJob.title}</h2>
                    <button className="job-close-button" onClick={closeModal}><FiX size={20} /></button>
                </div>
                    <form 
                    className="job-application-form"
                    onSubmit={handleFormSubmit}
                    encType="multipart/form-data"
                    >
                    <input type="hidden" name="Job Title" value={selectedJob.title} />

                    <label>
                        Full Name <span className="job-required">*</span>
                        <input 
                        type="text" 
                        name="Full Name" 
                        required 
                        placeholder="Enter your full name" 
                        />
                    </label>

                    <label>
                        Email Address <span className="job-required">*</span>
                        <input 
                        type="email" 
                        name="Email" 
                        required 
                        placeholder="Enter your email" 
                        />
                    </label>

                    <label>
                        Contact Number <span className="job-required">*</span>
                        <input 
                        type="tel" 
                        name="Phone" 
                        required 
                        placeholder="Enter your phone number" 
                        />
                    </label>

                    <label>
                        Upload Resume/CV <span className="job-required">*</span>
                        <div className="job-file-drop">
                        <input 
                            type="file" 
                            name="Resume" 
                            required 
                            accept=".pdf,.doc,.docx" 
                        />
                        </div>
                    </label>

                    <label>
                        Why are you interested in this role? <span className="job-required">*</span>
                        <textarea 
                        name="Interest" 
                        required 
                        placeholder="Tell us why you're a good fit..." 
                        />
                    </label>

                    <div className="bottom-button">
                        <button type="submit" className="job-submit-button">Submit Application</button>
                    </div>
                    </form>
                </motion.div>
            </motion.div>
            )}
        </AnimatePresence>
    {/* Thank You Modal */}
        <AnimatePresence>
            {showThankYou && (
    <div className="thank-you-wrapper">
        <motion.div
            className="thank-you-container"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <FiCheckCircle className="check-icon" />

            <h1>Thank You!</h1>
            <p>The form was submitted successfully.</p>

            <a href="/careers" className="back-link">
            <FiArrowLeft className="back-icon" />
            Back to Previous Page
            </a>
        </motion.div>
        </div>        )}
        </AnimatePresence>
            </>
    );
    };

    export default JobCard;
